import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import api from '../../../../../services/api';
import Header from '../../../components/Header';

import { SpinnerLoading } from '../../../../../components/SpinnerLoading';

import { useAuth } from '../../../../../hooks/auth';

interface IAlvara {
  id: number;
  numero_alvara: number;
  egress: {
    nome: string;
    cep: string;
    endereco: string;
    bairro: string;
    estado: string;
    municipio: string;
  };
  responsavel_execucao: any;
  executado: string;
  data_execucao: string;
  registro_seuu: string;
  attachment: {
    name:string;
    url_file: string;
  };
  observacao: string;
}

interface IProps {
  alvara: IAlvara;
  setAlvara: (value: IAlvara | null) => void;
}

function AlvaraDetail({ alvara, setAlvara } : IProps) {
  const { user } = useAuth();

  const [file, setFile] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  function cadastrar(): void {
    setLoading(true);
    const formData = new FormData();
    formData.append('data', JSON.stringify({ ...alvara, responsable_id_execucao: user.id }));
    // @ts-ignore
    formData.append('anexo', file);

    api.put(`licenses/${alvara.id}`, formData).then(({ data }) => {
      const message = `Alvará ${alvara.executado == 'T' ? 'cumprido' : 'atualizado'} com sucesso!`;

      toast(message, {
        type: 'success',
      });

      setAlvara(null);
      setFile(null);

      setLoading(false);
    }).catch((error) => {
      setLoading(false);
      const message = error.response.data.message || `Erro ao ${alvara.executado == 'T' ? 'cumprir' : 'atualizar'} alvará!`;

      toast(message, {
        type: 'error',
      });
    });
  }

  return (
    <>
      <Header route="cumprir-alvara" name="Cumprir alvará" alvara={alvara} setAlvara={setAlvara} />

      <div>
        <div style={{ display: 'flex', marginTop: 40 }}>
          <h1 style={{ fontSize: 20 }}>Nome do Egresso:</h1>
          <h1 style={{ fontSize: 20, marginLeft: 10, fontWeight: 'normal' }}>{alvara?.egress?.nome}</h1>
        </div>

        <div style={{ display: 'flex' }}>
          <h1 style={{ fontSize: 20 }}>Endereço do Egresso:</h1>
          <h1 style={{ fontSize: 20, marginLeft: 10, fontWeight: 'normal' }}>
            {`${alvara?.egress?.endereco}, ${alvara?.egress?.bairro}, ${alvara?.egress?.municipio} - ${alvara?.egress?.estado}`}
          </h1>
        </div>

        <div style={{ display: 'flex', marginTop: 10, alignItems: 'center' }}>
          <h1 style={{ fontSize: 20 }}>Executar?</h1>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 10,
          }}
          >
            <input
              onClick={() => {
                setAlvara({ ...alvara, executado: 'T' });
              }}
              style={{ marginBottom: 5 }}
              checked={alvara.executado == 'T'}
              type="radio"
              id="executado"
              name="executado"
              value="executado"
            />
            <label htmlFor="executado">Sim</label>

            <input
              onClick={() => {
                setAlvara({ ...alvara, executado: 'F' });
              }}
              style={{ marginBottom: 5, marginLeft: 10 }}
              checked={alvara.executado == 'F'}
              type="radio"
              id="executado"
              name="executado"
              value="executado"
            />
            <label htmlFor="executado">Não</label>
          </div>
        </div>

        <h2 style={{ fontSize: 11, color: '#595959', fontWeight: "normal" }}>Ao marcar SIM e confirmando no botão CUMPRIR a situação do alvará muda no sistema e a data será registrada também</h2>

        {/* <div style={{ display: 'flex', marginTop: 20, alignItems: 'center' }}>
          <h1 style={{ fontSize: 20 }}>Registrado no sistema SEUU?</h1>
          <div style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: 10,
          }}
          >
            <input
              onClick={() => {
                setAlvara({ ...alvara, registro_seuu: 'T' });
              }}
              style={{ marginBottom: 8 }}
              checked={alvara.registro_seuu == 'T'}
              type="radio"
              id="seuu"
              name="seuu"
              value="seuu"
            />
            <label htmlFor="seuu">Sim</label>

            <input
              onClick={() => {
                setAlvara({ ...alvara, registro_seuu: 'F' });
              }}
              style={{ marginBottom: 8, marginLeft: 10 }}
              checked={alvara.registro_seuu == 'F'}
              type="radio"
              id="seuu"
              name="seuu"
              value="seuu"
            />
            <label htmlFor="seuu">Não</label>
          </div>
        </div>

        <h2 style={{ fontSize: 11, color: '#595959', fontWeight: "normal" }}>Sinalize se este registro consta no sistema</h2> */}

        <h1 style={{ fontSize: 20, marginTop: 20 }}>Arquivos que fazem parte deste processo:</h1>

        <div
          style={{
            background: '#efefef', padding: 20,
          }}
          className="content"
        >
          <div>
            <input
              onChange={(e) => {
              // @ts-ignore
                setFile(e.target.files[0]);
              }}
              disabled={!!alvara.data_execucao}
              type="file"
              name="file"
              id="file"
              className="inputfile"
            />
            <div style={{
              display: 'flex', width: '40%', justifyContent: 'center', backgroundColor: "#ccc", padding: 10, borderRadius: 5,
            }}
            >
              <label style={{ cursor: "pointer", marginTop: 10 }} htmlFor="file">{file ? file.name : 'Clique para anexar arquivos'}</label>
            </div>
          </div>

          {alvara.attachment && (
          <>
            <h1 style={{ fontSize: 14, marginTop: 20 }}>Clique no link abaixo para visualizar o arquivo anexado (caso queira alterar o arquivo só clicar no botão acima):</h1>
            <label onClick={() => window.open(alvara.attachment.url_file, '_blank')} style={{ cursor: "pointer", color: '#007BFF' }} htmlFor="file">{alvara.attachment.name ? alvara.attachment.name : 'Clique para anexar arquivos'}</label>
          </>
          )}

        </div>

        <h2 style={{
          fontSize: 11, color: '#595959', fontWeight: "normal", marginTop: 10,
        }}
        >
          Arquivos utilizados para apoiar o processo, podem ser usados documentos até o limite de 100 MB no total, caso passe o sistema avisará
        </h2>

        <h1 style={{ fontSize: 20, marginBottom: 5, marginTop: 20 }}>Observação</h1>
        <h2 style={{ fontSize: 11, color: '#595959', fontWeight: "normal" }}>Registro de problemas que impediram a fiscalização</h2>

        <textarea
          style={{
            marginBottom: 20, borderRadius: 5, padding: 10, width: '100%',
          }}
          value={alvara.observacao}
          onChange={(e) => setAlvara({ ...alvara, observacao: e.target.value })}
          rows={5}
        />

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <div
            onClick={() => setAlvara(null)}
            style={{
              display: "flex", width: '20%', justifyContent: "center", cursor: 'pointer', backgroundColor: "#f00", padding: 10, borderRadius: 5,
            }}
          >
            <h1 style={{ color: '#fff', fontSize: 14, marginTop: 10 }}>{!alvara.data_execucao ? 'Cancelar' : 'Fechar'}</h1>
          </div>

          {!alvara.data_execucao
          && (
          <div
            onClick={cadastrar}
            style={{
              display: "flex", width: '20%', marginLeft: 10, justifyContent: "center", cursor: 'pointer', backgroundColor: "#080", padding: 10, borderRadius: 5,
            }}
          >
            {!loading ? <h1 style={{ color: '#fff', fontSize: 14, marginTop: 10 }}>{alvara.executado == 'T' ? 'Cumprir' : 'Atualizar'}</h1> : <SpinnerLoading color="#fff" size={30} />}
          </div>
          )}
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default AlvaraDetail;
